<template>
  <div class="m-6">
    <h2>Timeline (Pro)</h2>
  </div>
</template>

<script>
export default {
  name: "TimelineSubpage",
  data: () => ({
  }),
  computed: {
    goal_id() {
      return this.$route.params.goalId;
    },
    goal_meta() {
      return this.$models.goalMeta.subscribeNode( this.goal_id );
    },
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
